"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicButtonClose = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Close_1 = require("../../icons/interactive/Close");
const _1 = tslib_1.__importDefault(require("."));
const BasicButtonClose = (props) => {
    return (React.createElement(_1.default, { ...props },
        React.createElement(Close_1.Close, null)));
};
exports.BasicButtonClose = BasicButtonClose;
